export default {
  SET_conditions(state, payload) {
    state.conditions = payload
  },
}
